/**
 * Remove duplicate items (objects or primitives) from an array.
 * For objects, keys are sorted before comparison so that
 * {a:1, b:2} and {b:2, a:1} are treated as equal.
 *
 * @param {Array} array - The array to deduplicate.
 *
 * @returns {Array} - A new array with unique items.
 */
export default function uniqueObjectsByKey(array) {
  if (!Array.isArray(array)) return array;

  const serialize = (item) => {
    if (item && typeof item === "object" && !Array.isArray(item)) {
      return JSON.stringify(
        Object.keys(item)
          .sort()
          .reduce((acc, key) => {
            acc[key] = serialize(item[key]);
            return acc;
          }, {})
      );
    }
    if (Array.isArray(item)) {
      return JSON.stringify(item.map(serialize));
    }
    return JSON.stringify(item);
  };

  return [...new Map(array.map((item) => [serialize(item), item])).values()];
}
